export const setLetterSpacing = (ctx, px) => {
  if ('letterSpacing' in ctx) ctx.letterSpacing = px;
};
